import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClapboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"clapboard, movie, film"} maskId="square-filled-radius-0-stroke-1-IconClapboard"><path d="M21 21H3V9H21V21Z" fill="currentColor"/><path d="M6.92969 8H3V3H9.22168L6.92969 8Z" fill="currentColor"/><path d="M13.4297 8H8.02832L10.3203 3H15.7217L13.4297 8Z" fill="currentColor"/><path d="M21 8H14.5283L16.8203 3H21V8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconClapboard;
